import { Box, Container, Typography } from '@mui/material';

interface HeaderProps {
    children?: React.ReactNode;
}

const Header = ({ children }: HeaderProps) => {

    return (

        <Box id="header">
            <Container className="center-container">
                <Box className="center-item-left">
                    <Typography data-test-id="top-header-text" variant="h4" component="h1" gutterBottom>
                        {children}
                    </Typography>
                </Box>
            </Container>
        </Box> 
    );
}

export default Header;